// Quels camions sont LOUÉS en ce moment ? Sert au badge « En location » de la
// liste des véhicules et de la fiche.
//
// UNE REQUÊTE POUR TOUTE LA FLOTTE, pas une par camion : la liste affiche vingt
// lignes, et vingt appels pour une pastille se verraient sur un téléphone.
//
// SEULEMENT UNE LOCATION SIGNÉE : un brouillon réserve le camion mais il n'est
// pas encore parti — afficher « En location » serait annoncer un fait faux.
//
// MUETTE EN CAS D'ÉCHEC : une pastille manquante est un confort perdu, pas une
// erreur à montrer au milieu de la liste des véhicules.
import { useEffect, useState } from "react";

import api from "./api";

export function useVehiculesLoues(user, modules) {
  const [loues, setLoues] = useState(new Set());
  // Le mécanicien n'a pas accès au module : lui demander répondrait 403.
  const autorise = Boolean(modules.module_location) && user.role !== "mecanicien";

  useEffect(() => {
    if (!autorise) return;
    let vivant = true;
    api
      .get("/locations", { params: { etat: "en_cours" } })
      .then(({ data }) => {
        if (vivant) {
          setLoues(new Set(data.filter((l) => l.statut === "signee").map((l) => l.vehicule_id)));
        }
      })
      .catch(() => {});
    return () => {
      vivant = false;
    };
  }, [autorise]);

  return loues;
}
